import axiosService from './axiosService';

export const getAllFuelLogs = (fuelTankId) => {
  return axiosService.get("/fuelLog/fuelTank?fuelTankId=" + fuelTankId);
}

export const deleteFuelLog = (fuelLogId) => {
  return axiosService.delete("/fuelLog/" + fuelLogId);
}